import React from 'react'

export const MyMImage = (props) => {
  const { screenId, filePath, alt, ...other } = props;
  return (
    <img src={process.env.PUBLIC_URL + "/" + screenId + "/" + filePath} alt={ alt } {...other} />
  )
}
